import { tv } from 'tailwind-variants';

import { createHeadingTextComponent, type HeadingTextProps } from './utils';

const titleVariants = tv({
    base: ['m-0', 'font-kalshi-sans'],
    variants: {
        size: {
            x10: 'typ-title-x10',
            x20: 'typ-title-x20',
            x30: 'typ-title-x30',
        },
        medium: {
            true: 'font-medium',
        },
        semibold: {
            true: 'font-semibold',
        },
        underline: {
            true: 'underline-link',
        },
        balance: {
            true: 'text-balance',
        },
    },
    defaultVariants: {
        underline: false,
        balance: false,
    },
});

/**
 * Title Components
 *
 * Semibold titles for cards, sections, and dialog headers.
 * Uses KalshiSans Semibold font.
 *
 * @example
 * <Title.x10 as="h3">Market Details</Title.x10>
 * <Title.x20 underline>Learn More</Title.x20>
 * <Title.x10 className="text-text-x20">Subtitle</Title.x10>
 */
export const Title = {
    /** Title x10 - 15px/22px, KalshiSans Semibold */
    x10: createHeadingTextComponent(titleVariants, 'Title.x10', 'x10'),
    /** Title x20 - 18px/24px, KalshiSans Semibold */
    x20: createHeadingTextComponent(titleVariants, 'Title.x20', 'x20'),
    /** Title x30 - 24px/26px, KalshiSans Semibold */
    x30: createHeadingTextComponent(titleVariants, 'Title.x30', 'x30'),
} as const;

export default Title;
export { titleVariants };
export type TitleProps = HeadingTextProps;
